// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function toString(tabId) {
  switch (tabId) {
    case /* Active */0 :
        return "ACTIVE";
    case /* Scheduled */1 :
        return "SCHEDULED";
    case /* PendingForReview */2 :
        return "PENDING";
    
  }
}

function fromString(tab) {
  switch (tab) {
    case "active" :
        return /* Active */0;
    case "pending" :
        return /* PendingForReview */2;
    case "scheduled" :
        return /* Scheduled */1;
    default:
      return ErrorUtils$Catalyst.raiseError("FilterAllocationTableTab.res", "invalid campaign status", tab);
  }
}

export {
  toString ,
  fromString ,
  
}
/* No side effect */
